export default ({ store }, inject) => {
  if (process.server) { return }
  if (window.__chatbasePluginInitialized) { return }

  window.__chatbasePluginInitialized = true

  let loaded = false
  let identified = false
  let timeoutId = null

  const scriptId = 'eUFR9_1_8VEJBNz5OvleK'
  const triggerEvents = ['click', 'keydown', 'touchstart', 'scroll']

  const blockedPaths = [
    '/wohnmobil-verkaufen-online',
    '/preisentwicklung-wohnmobilverkauf',
    '/schwacke-liste-wohnmobilverkauf',
    '/wohnwagen-verkaufen-online',
    '/erfahrungen-wohnmobilverkauf',
    '/rdw-opkoper',
    '/prijsontwikkeling-campers',
    '/aankoop-camper',
    '/ervaringen',
    '/camper-verkopen-online'
  ]

  const isBlockedPath = () =>
    blockedPaths.includes(window.location.pathname)

  const isMerchant = () => {
    const merchantId = store?.state?.customer?.merchant?.merchantId
    return typeof merchantId === 'number' && !Number.isNaN(merchantId)
  }

  const shouldDisableChatbase = () =>
    isBlockedPath() || isMerchant()

  const ensureBootstrap = () => {
    if (
      !window.chatbase ||
      window.chatbase('getState') !== 'initialized'
    ) {
      window.chatbase = (...args) => {
        if (!window.chatbase.q) {
          window.chatbase.q = []
        }
        window.chatbase.q.push(args)
      }

      window.chatbase = new Proxy(window.chatbase, {
        get (target, prop) {
          if (prop === 'q') { return target.q }
          return (...args) => target(prop, ...args)
        }
      })
    }
  }

  const cleanupTriggers = () => {
    triggerEvents.forEach((event) => {
      window.removeEventListener(event, lazyLoadHandler, passiveOptions)
    })

    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
  }

  const loadChatbase = () => {
    if (loaded || shouldDisableChatbase()) { return }
    loaded = true

    cleanupTriggers()
    ensureBootstrap()

    if (document.getElementById(scriptId)) { return }

    const script = document.createElement('script')
    script.src = 'https://www.chatbase.co/embed.min.js'
    script.id = scriptId
    script.async = true
    script.setAttribute('domain', 'www.chatbase.co')

    document.body.appendChild(script)
  }

  const identifyUser = async () => {
    console.log('identifyUser')
    if (identified || shouldDisableChatbase()) { return }

    const isLoggedIn = store?.state?.auth?.loggedIn
    if (!isLoggedIn) { return }

    loadChatbase()

    try {
      const response = await fetch('/api/chatbase-token', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      })

      if (!response.ok) { return }

      const { token } = await response.json()

      if (!token) { return }

      console.log('token', token)
      window.chatbase('identify', { token })
      identified = true
    } catch (e) {
      console.error('Chatbase identify failed', e)
    }
  }

  const lazyLoadHandler = () => {
    loadChatbase()
  }

  const passiveOptions = { passive: true }

  if (!shouldDisableChatbase()) {
    triggerEvents.forEach((event) => {
      window.addEventListener(event, lazyLoadHandler, passiveOptions)
    })

    timeoutId = setTimeout(() => {
      loadChatbase()
    }, 10000)
  }

  inject('chatbaseIdentify', identifyUser)
  inject('loadChatbase', loadChatbase)
}
